import React, { useState, useEffect } from "react";
import '../App.css';
import { Link } from "react-router-dom";
import '../styles/menus.css';

// import components
import LeftMenuItem from './LeftMenuItem.js';

// import assets
import jv_logo from '../assets/jv_logo.png';
import tasks from '../assets/icon_tasks_gray.png';
import tasks_white from '../assets/icon_tasks_white.png';
import projects from '../assets/icon_projects_gray.png';
import projects_white from '../assets/icon_projects_white.png';
import applications from '../assets/icon_applications_gray.png';
import applications_white from '../assets/icon_applications_white.png';
import funding from '../assets/icon_funding_gray.png';
import funding_white from '../assets/icon_funding_white.png';
import grants from '../assets/icon_grants_gray.png';
import grants_white from '../assets/icon_grants_white.png';
import workflow from '../assets/icon_workflow_gray.png';
import workflow_white from '../assets/icon_workflow_white.png';
import dashboard from '../assets/icon_dashboard.png';
import dashboard_white from '../assets/icon_dashboard_white.png';
import reports from '../assets/icon_reports.png';
import reports_white from '../assets/icon_reports_white.png';
import left from '../assets/icon_left.png';

class LeftMenu extends React.Component {
    setActualSection = this.props.setActualSection;

    constructor(props) {
        super(props);
    }

    isTasksActive(actualSection){
        if(actualSection == "tasks")return true;
        return false;
    }

    isProjectsActive(actualSection){
        if(actualSection == "projects")return true;
        return false;
    }

    isApplicationsActive(actualSection){
        if(actualSection == "applications")return true;
        return false;
    }

    isFundingActive(actualSection){
        if(actualSection == "funding")return true;
        return false;
    }

    isGrantsActive(actualSection){
        if(actualSection == "grants")return true;
        return false;
    }

    isProjWorkflowActive(actualSection){
        if(actualSection == "proj_workflow")return true;
        return false;
    }

    isSubmissionsActive(actualSection){
        if(actualSection == "submissions")return true;
        return false;
    }

    isFinWorkflowActive(actualSection){
        if(actualSection == "fin_workflow")return true;
        return false;
    }

    isFinDashboardActive(actualSection){
        if(actualSection == "fin_dashboard")return true;
        return false;
    }

    isFinReports(actualSection){
        if(actualSection == "fin_reports")return true;
        return false;
    }

    render(){
        return(
            <div className="mainLeftMenu">
                <div className="verticalStackCenter" style={{alignItems: "center"}}>
                    <Link className="link" to={"./"} >
                        <img style={{width: "185px"}} src={jv_logo}/>
                    </Link>
                </div>

                <div style={{height: "30px"}}></div>

                <div className="verticalStack hideVerticalScrollBar" style={{position: "relative", overflowY: "scroll", height: "calc(100vh - 27px - 35px - 17px - 10px - 60px)"}}>

                    <div className="horizontalStackCenter menuLeftSection">
                        <span className="menuLeftSectionTitle" style={{whiteSpace: "nowrap"}}>{"GLOBAL"}</span>
                        <div style={{ borderTop: "1px solid var(--left-menu-line)", width: "100vh", marginLeft: "5px" }}></div>
                    </div>

                    <div onClick={() => {this.setActualSection("tasks");localStorage.setItem("actualPageTasks", 0);localStorage.setItem("sortByTasks", "");localStorage.setItem("sortTpTasks", "asc");}}>
                        <LeftMenuItem title={"My Tasks"} link="./" icon={this.isTasksActive(this.props.actualSection) ? tasks_white : tasks} active={this.isTasksActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div className="horizontalStackCenter menuLeftSection">
                        <span className="menuLeftSectionTitle" style={{whiteSpace: "nowrap"}}>{"PROJECTS PIPELINE"}</span>
                        <div style={{ borderTop: "1px solid var(--left-menu-line)", width: "100vh", marginLeft: "5px"}}></div>
                    </div>

                    <div onClick={() => {this.setActualSection("projects");localStorage.setItem("actualPageProjects", 0);localStorage.setItem("sortByProjects", "");localStorage.setItem("sortTpProjects", "asc");}}>
                        <LeftMenuItem title={"Projects"} link="./Projects" icon={this.isProjectsActive(this.props.actualSection) ? projects_white : projects} active={this.isProjectsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div onClick={() => {this.setActualSection("applications");localStorage.setItem("actualPageApplications", 0);localStorage.setItem("sortByApplications", "");localStorage.setItem("sortTpApplications", "asc");}}>
                        <LeftMenuItem title={"Applications"} link="./Applications" icon={this.isApplicationsActive(this.props.actualSection) ? applications_white : applications} active={this.isApplicationsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div onClick={() => {this.setActualSection("funding");localStorage.setItem("actualPageFunding", 0);localStorage.setItem("sortByFunding", "");localStorage.setItem("sortTpFunding", "asc");}}>
                        <LeftMenuItem title={"Funding"} link="./Fundings" icon={this.isFundingActive(this.props.actualSection) ? funding_white : funding} active={this.isFundingActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div onClick={() => {this.setActualSection("grants");localStorage.setItem("actualPageGrants", 0);localStorage.setItem("sortByGrants", "");localStorage.setItem("sortTpGrants", "asc");}}>
                        <LeftMenuItem title={"Grants"} link="./Grants" icon={this.isGrantsActive(this.props.actualSection) ? grants_white : grants} active={this.isGrantsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div onClick={() => {this.setActualSection("proj_workflow");localStorage.setItem("actualPageProjWorkflow", 0);localStorage.setItem("sortByProjWorkflow", "");localStorage.setItem("sortTpProjWorkflow", "asc");}}>
                        <LeftMenuItem title={"Workflow"} link="./ProjWorkflow" icon={this.isProjWorkflowActive(this.props.actualSection) ? workflow_white : workflow} active={this.isProjWorkflowActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div className="horizontalStackCenter menuLeftSection">
                        <span className="menuLeftSectionTitle" style={{whiteSpace: "nowrap"}}>{"FINANCIAL STATEMENTS"}</span>
                        <div style={{ borderTop: "1px solid var(--left-menu-line)", width: "100vh", marginLeft: "5px"}}></div>
                    </div>

                    <div onClick={() => {this.setActualSection("fin_dashboard");localStorage.setItem("actualPageFinDashboard", 0);localStorage.setItem("sortByFinDashboard", "");localStorage.setItem("sortTpFinDashboard", "asc");}}>
                        <LeftMenuItem title={"Dashboard"} link="./FinDashboard" icon={this.isFinDashboardActive(this.props.actualSection) ? dashboard_white : dashboard} active={this.isFinDashboardActive(this.props.actualSection)} iconStyle={{height: 21}} />
                    </div>

                    <div onClick={() => {this.setActualSection("fin_reports");localStorage.setItem("actualPageFinReports", 0);localStorage.setItem("sortByFinReports", "");localStorage.setItem("sortTpFinReports", "asc");}}>
                        <LeftMenuItem title={"Reports"} link="./FinReports" icon={this.isFinReports(this.props.actualSection) ? reports_white : reports} active={this.isFinReports(this.props.actualSection)} iconStyle={{height: 20, marginLeft: 3}} />
                    </div>

                    <div onClick={() => {this.setActualSection("submissions");localStorage.setItem("actualPageSubmissions", 0);localStorage.setItem("sortBySubmissions", "");localStorage.setItem("sortTpSubmissions", "asc");}}>
                        <LeftMenuItem title={"Submissions"} link="./Submissions" icon={this.isSubmissionsActive(this.props.actualSection) ? applications_white : applications} active={this.isSubmissionsActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div onClick={() => {this.setActualSection("fin_workflow");localStorage.setItem("actualPageFinWorkflow", 0);localStorage.setItem("sortByFinWorkflow", "");localStorage.setItem("sortTpFinWorkflow", "asc");}}>
                        <LeftMenuItem title={"Workflow"} link="./FinWorkflow" icon={this.isFinWorkflowActive(this.props.actualSection) ? workflow_white : workflow} active={this.isFinWorkflowActive(this.props.actualSection)} iconStyle={{height: 17, marginLeft: 3}} />
                    </div>

                    <div onClick={() => this.props.setLeftMenuOpened("false")}>
                        <div className="closeLeftMenuButton"></div>
                    </div>

                </div>
            </div>
        );
	}
}

export default LeftMenu;